import React, {ReactElement} from 'react';
import {useDispatch} from 'ui/store';
import {openSettings} from 'store/UI';
import {Button, SectionConstraints} from 'components/Button';

export const UpdateSettingsButton = (): ReactElement => {
  const showSettings = useDispatch(openSettings);

  return (
    <SectionConstraints>
      <Button onPress={showSettings} color='yellow' data-test='button'>
        Изменить срок и сумму
      </Button>
    </SectionConstraints>
  );
};
